export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/analysisWorker.16f6c6e0.worker.js");
}
